import ReactGA from 'react-ga' // TODO: UAが廃止されたら削除
import ReactGA4 from 'react-ga4'
import { MedicalInstitutionProps, ReservationDetailProps } from 'types/med'
import { MedicalInstitutionProps as PersonalMedicalInstitutionProps } from 'types/applicant'

const medicalLogin: (data: { med: MedicalInstitutionProps }) => void = ({
  med,
}) => {
  ReactGA4.event({
    category: 'medical.status',
    action: 'login',
    label: `[${med.id}] ${med.name}`,
  })
  // TODO: UAが廃止されたら削除
  ReactGA.event({
    category: 'medical.status',
    action: 'login',
    label: `[${med.id}] ${med.name}`,
  })
}

const medicalVideoChatStart: (data: {
  med: MedicalInstitutionProps
  reservation: ReservationDetailProps
  type: 'zoom' | 'teams' | string
}) => void = ({ med, reservation, type }) => {
  ReactGA4.event({
    category: 'medical.videoChat',
    action: `${type}.start`,
    label: `[${med.id}] ${med.name}`,
    value: reservation.id,
  })
  // TODO: UAが廃止されたら削除
  ReactGA.event({
    category: 'medical.videoChat',
    action: `${type}.start`,
    label: `[${med.id}] ${med.name}`,
    value: reservation.id,
  })
}

const personalReservationFinished: (data: {
  med: PersonalMedicalInstitutionProps
}) => void = ({ med }) => {
  ReactGA4.event({
    category: 'personal.reservation',
    action: `finished`,
    label: `[${med.name}] ${med.name}`,
  })
  // TODO: UAが廃止されたら削除
  ReactGA.event({
    category: 'personal.reservation',
    action: `finished`,
    label: `[${med.name}] ${med.name}`,
  })
}

const Default = {
  medicalLogin,
  medicalVideoChatStart,
  personalReservationFinished,
}

export default Default
